import { render, staticRenderFns } from "./DocumentViewer.vue?vue&type=template&id=186bae74&scoped=true"
import script from "./DocumentViewer.vue?vue&type=script&lang=ts"
export * from "./DocumentViewer.vue?vue&type=script&lang=ts"
import style0 from "./DocumentViewer.vue?vue&type=style&index=0&id=186bae74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186bae74",
  null
  
)

export default component.exports